/* @flow */

import * as React from "react";

import { FormGroup } from "react-bootstrap";
import InputRange from "react-input-range";
import * as FacetUtil from "../../../../utils/FacetUtil";
import { FacetResult } from "shared/src/types/articlesearch/Facets";

type Props = {
    facet: FacetResult;
    selectedValues: {
        selectedMax?: number | null;
        selectedMin?: number | null;
    };
    onFacetValueChange: (key: string, minValue: number | undefined | null, maxValue: number | undefined | null) => void;
    className: string; // currently only for testing, not actually applied
};

type State = {
    selectedMax: number | undefined | null;
    selectedMin: number | undefined | null;
};

type Value = {
    min: number;
    max: number;
};

export class FacetRangeSelect extends React.Component<Props, State> {
    state = { selectedMax: null, selectedMin: null };

    updateState(value: Value) {
        this.setState({ selectedMax: value.max, selectedMin: value.min });
    }

    handleFacetChange(value: Value) {
        this.setState({ selectedMax: null, selectedMin: null });
        const facet = this.props.facet;
        const minValue = value.min <= Number(facet.numberMin) ? null : value.min;
        const maxValue = value.max >= Number(facet.numberMax) ? null : value.max;
        this.props.onFacetValueChange(facet.key, minValue, maxValue);
    }

    render() {
        const facet = this.props.facet;
        const scaleObject = FacetUtil.computeRangeForFacet(facet);
        const { maxValue, minValue } = FacetUtil.getNumericFacetRange(facet);

        const selectedMin =
            this.state.selectedMin === null
                ? FacetUtil.maxWithoutNull(this.props.selectedValues.selectedMin, Number(this.props.facet.numberMin))
                : this.state.selectedMin;
        const selectedMax =
            this.state.selectedMax === null
                ? FacetUtil.minWithoutNull(this.props.selectedValues.selectedMax, Number(this.props.facet.numberMax))
                : this.state.selectedMax;

        if (maxValue === minValue) {
            return null;
        }
        return (
            <FormGroup>
                <div className="input-range-double">
                    <InputRange
                        formatLabel={(value) =>
                            FacetUtil.roundNumericFacetValue(value, scaleObject) + " " + (facet.numberUnit || "")
                        }
                        maxValue={maxValue!}
                        minValue={minValue!}
                        step={scaleObject.small ? 1 / scaleObject.scale : scaleObject.scale}
                        value={{ min: selectedMin!, max: selectedMax! }}
                        onChange={(value) => this.updateState(value as any)}
                        onChangeComplete={(value) => this.handleFacetChange(value as any)}
                    />
                </div>
            </FormGroup>
        );
    }
}
